import { render, staticRenderFns } from "./ContactEdit.vue?vue&type=template&id=5025e77e&scoped=true"
import script from "./ContactEdit.vue?vue&type=script&lang=ts"
export * from "./ContactEdit.vue?vue&type=script&lang=ts"
import style0 from "./ContactEdit.vue?vue&type=style&index=0&id=5025e77e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5025e77e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5025e77e')) {
      api.createRecord('5025e77e', component.options)
    } else {
      api.reload('5025e77e', component.options)
    }
    module.hot.accept("./ContactEdit.vue?vue&type=template&id=5025e77e&scoped=true", function () {
      api.rerender('5025e77e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contacts/ContactEdit.vue"
export default component.exports